import { render, staticRenderFns } from "./PriceToEarningRatio.vue?vue&type=template&id=49389211&scoped=true&"
import script from "./PriceToEarningRatio.vue?vue&type=script&lang=js&"
export * from "./PriceToEarningRatio.vue?vue&type=script&lang=js&"
import style0 from "./PriceToEarningRatio.vue?vue&type=style&index=0&id=49389211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49389211",
  null
  
)

export default component.exports